const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Catálogo de Servicios y Tratamientos",
    summary:
      "Administra el catálogo de servicios ofrecidos por tu empresa. Define nombres comerciales, descripciones detalladas, duración estimada en minutos, precios y tarifas para agilizar la cotización y la reserva automática de citas.",
  },
  sections: [
    {
      id: "catalogo_servicios",
      title: "1. Estructura y Parámetros del Servicio",
      description:
        "Definición técnica de cada prestación comercial.",
      items: [
        {
          id: "nombre_descripcion",
          title: "Nombre Comercial y Descripción",
          definition:
            "Título claro y resumen de los alcances del servicio que verán tanto los operadores en el CRM como los clientes en la página de auto-reserva.",
        },
        {
          id: "duracion_minutos",
          title: "Duración Estimada (Minutos)",
          definition:
            "Tiempo exacto que ocupará la sesión en el calendario (ej: 30, 45, 60 min). El sistema usa este valor para calcular los bloques de disponibilidad en la agenda.",
        },
        {
          id: "precio_tarifa",
          title: "Precio y Moneda",
          definition:
            "Valor monetario estándar del servicio para transparencia en cotizaciones y control financiero.",
        },
      ],
    },
    {
      id: "asociacion_especialistas",
      title: "2. Vinculación con Profesionales",
      description:
        "Relación entre especialidades y el equipo de trabajo.",
      items: [
        {
          id: "asignacion_habilitada",
          title: "Especialistas Habilitados",
          definition:
            "Cada servicio puede ser prestado por uno o varios profesionales. El cliente solo podrá seleccionar entre los profesionales asignados a ese servicio.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Services & Treatments Catalog",
    summary:
      "Manage your organization's service catalog. Define commercial service titles, detailed descriptions, estimated session duration in minutes, and pricing to streamline quotes and self-service booking workflows.",
  },
  sections: [
    {
      id: "catalogo_servicios",
      title: "1. Service Specifications & Structure",
      description:
        "Technical configuration for each commercial offering.",
      items: [
        {
          id: "nombre_descripcion",
          title: "Service Title & Scope",
          definition:
            "Clear title and explanatory description displayed to CRM agents and to customers on the public self-booking page.",
        },
        {
          id: "duracion_minutos",
          title: "Estimated Duration (Minutes)",
          definition:
            "The exact timespan reserved in the calendar (e.g., 30, 45, 60 mins). Used by the algorithm to generate open booking slots.",
        },
        {
          id: "precio_tarifa",
          title: "Standard Pricing",
          definition:
            "Standard price for the service to ensure transparent client quotes and operational accounting.",
        },
      ],
    },
    {
      id: "asociacion_especialistas",
      title: "2. Staff & Professional Assignments",
      description:
        "Connecting capabilities with active team members.",
      items: [
        {
          id: "asignacion_habilitada",
          title: "Qualified Practitioners",
          definition:
            "Each service can be offered by one or multiple professionals. Clients will only see qualified specialists eligible for that service.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Catálogo de Serviços e Procedimentos",
    summary:
      "Gerencie o catálogo de serviços prestados pela sua empresa. Cadastre títulos comerciais, descrições completas, duração estimada em minutos e valores para facilitar orçamentos e agendamentos automatizados.",
  },
  sections: [
    {
      id: "catalogo_servicios",
      title: "1. Parâmetros e Detalhes do Serviço",
      description:
        "Configuração dos itens ofertados aos clientes.",
      items: [
        {
          id: "nombre_descripcion",
          title: "Nome Comercial e Descrição",
          definition:
            "Nome e resumo detalhado da prestação visíveis tanto para os atendentes quanto para o cliente na página pública.",
        },
        {
          id: "duracion_minutos",
          title: "Duração Estimada (Minutos)",
          definition:
            "Tempo necessário para a realização do atendimento (ex: 30, 45, 60 min). O sistema utiliza essa métrica para calcular os horários livres na agenda.",
        },
        {
          id: "precio_tarifa",
          title: "Preço e Tabela de Valores",
          definition:
            "Valor cobrado pelo serviço para transparência nas propostas e controle operacional.",
        },
      ],
    },
    {
      id: "asociacion_especialistas",
      title: "2. Vinculação com Profissionais",
      description:
        "Associação entre as competências e a equipe de especialistas.",
      items: [
        {
          id: "asignacion_habilitada",
          title: "Profissionais Habilitados",
          definition:
            "Cada serviço pode ser atendido por um ou mais profissionais. O cliente só visualizará especialistas capacitados para aquele procedimento.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Catalogue des Services et Prestations",
    summary:
      "Gérez l'ensemble des prestations proposées par votre établissement. Définissez les intitulés commerciaux, descriptions détaillées, durées prévues en minutes et tarifs pour simplifier la tarification et la réservation en ligne.",
  },
  sections: [
    {
      id: "catalogo_servicios",
      title: "1. Paramètres et Définition du Service",
      description:
        "Configuration technique de chaque prestation commerciale.",
      items: [
        {
          id: "nombre_descripcion",
          title: "Intitulé Commercial et Description",
          definition:
            "Titre clair et présentation des prestations affichés aux agents CRM et aux clients sur la page de réservation.",
        },
        {
          id: "duracion_minutos",
          title: "Durée Estimée (Minutes)",
          definition:
            "Temps bloqué sur l'agenda pour ce service (ex: 30, 45, 60 min). Le système calcule automatiquement les créneaux disponibles selon cette valeur.",
        },
        {
          id: "precio_tarifa",
          title: "Tarif et Facturation",
          definition:
            "Prix standardisé de la prestation garantissant la clarté des devis et la gestion comptable.",
        },
      ],
    },
    {
      id: "asociacion_especialistas",
      title: "2. Affectation aux Professionnels",
      description:
        "Liaison entre les compétences requises et l'équipe intervenante.",
      items: [
        {
          id: "asignacion_habilitada",
          title: "Praticiens Habilités",
          definition:
            "Chaque service peut être assuré par un ou plusieurs spécialistes. Le client ne verra que les praticiens qualifiés pour ce soin.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "دليل الخدمات والعلاجات",
    summary:
      "إدارة شاملة لدليل الخدمات التي تقدمها منشأتك. يتيح تحديد المسميات التجارية، الأوصاف التفصيلية، المدة التقديرية بالدقائق والأسعار لتسريع عروض الأسعار وحجز المواعيد الآلية.",
  },
  sections: [
    {
      id: "catalogo_servicios",
      title: "1. إعدادات ومعايير الخدمة",
      description:
        "التهيئة الفنية لكل خدمة تجارية متاحة.",
      items: [
        {
          id: "nombre_descripcion",
          title: "الاسم التجاري والوصف",
          definition:
            "عنوان واضح وشرح لطبيعة الخدمة يظهر لموظفي خدمة العملاء وكذلك للعملاء في صفحة الحجز الذاتي.",
        },
        {
          id: "duracion_minutos",
          title: "المدة التقديرية (بالدقائق)",
          definition:
            "الوقت المستغرق لإتمام الخدمة في جدول المواعيد (مثال: 30، 45، 60 دقيقة). يعتمد النظام عليها لحساب الفترات الشاغرة.",
        },
        {
          id: "precio_tarifa",
          title: "السعر والتعرفة القياسية",
          definition:
            "التكلفة المعتمدة للخدمة لضمان الشفافية في التقديرات والرقابة المالية الدقيقة.",
        },
      ],
    },
    {
      id: "asociacion_especialistas",
      title: "2. الربط مع الأخصائيين والمهنيين",
      description:
        "توزيع الخدمات والمهام على فريق العمل المؤهل.",
      items: [
        {
          id: "asignacion_habilitada",
          title: "المختصون المتاحون للخدمة",
          definition:
            "يمكن تقديم الخدمة بواسطة أخصائي واحد أو أكثر. لن يتمكن العميل إلا من اختيار المختصين المؤهلين لتقديم تلك الخدمة تحديداً.",
        },
      ],
    },
  ],
};

export const SERVICES_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
